import {NgModule} from '@angular/core';
import {FollowUpComponent} from './follow-up.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [
    FollowUpComponent,
  ],
  exports: [
    FollowUpComponent,
  ]
})
export class FollowUpModule {
}
